<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <breadcrumb-header :title="title" :path="path" :text="text" />
      <!-- /Page Header -->

      <div class="row">
        <div class="col-md-12">
          <div class="showentries mb-3 custom-select">
            <div class="d-flex align-items-center gap-2"><span>Show</span>
              <select v-model="perPage" @change="current = 1; pendingList()" style="outline: none">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span>entries</span>
            </div>
          </div>
          <div class="table-responsive overflow-visible" v-if="!loading">
            <a-table class="stripped table-hover" :columns="columns" :data-source="userLeavesData" :pagination="false" :scroll="{ x: 1150 }">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'user_id'">
                  <h2 class="table-avatar">
                    <action-dropdown @banked-time="bankedTimeClicked" :employee="{...employeeData.find(item => item.id === record.user_id), name: getEmployeeName(record.user_id), id: record.user_id}" variant="text" :reportAsEvent="true" @edit="editClicked" @leaves="leavesClicked"
                        @attendance="attendanceClicked" @sick-leave="sickLeaveClicked" @add-face-template="addFaceTemplateClicked" @face-templates="faceTemplatesClicked" @toggle-monitoring="monitorClicked" @report="viewReport"
                        @reset-password="resetPasswordClicked" @assign-employee="assignEmployeeClicked" />
                  </h2>
                </template>
                <template v-else-if="column.key === 'work_in_minutes'">

                  {{ toTimeString(record.work_in_minutes) }}

                </template>
                <template v-else-if="column.key === 'status'">
                  <div class="text-start">
                    <div class="action-label">
                      <a class="btn btn-white btn-sm" href="javascript:void(0);">
                        <i :class="record.class"></i>
                        {{ record.status }}
                      </a>
                    </div>

                  </div>
                </template>
                <template v-else-if="column.key === 'updated_by'">
                  {{ record.updated_by_user ? (record.updated_by_user.first_name + ' ' + record.updated_by_user.last_name) : (record.updated_by && record.updated_by.first_name ? (record.updated_by.first_name + ' ' + record.updated_by.last_name) : (record.updated_by ? record.updated_by : '--')) }}
                </template>
                <template v-else-if="column.key === 'updated_at'">
                  {{ record.updated_at ? formatDateTimeStandardWithTime(record.updated_at) : '--' }}
                </template>
                <template v-else-if="column.key === 'action'">
                  <div class="text-end">
                    <div class="dropdown dropdown-action">
                      <a href="javascript:void(0);" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                        aria-expanded="false"><i class="material-icons">more_vert</i></a>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="javascript:;" @click="updateStatus(record.id, 'Accepted')"><i
                            class="fa-solid fa-check m-r-5"></i>Accept</a>
                        <a class="dropdown-item" href="javascript:;" @click="updateStatus(record.id, 'Rejected')"><i
                            class="fa-solid fa-xmark m-r-5"></i>Reject</a>
                        <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#banked_time_details_modal"
                          @click="view(record, getEmployeeName(record.user_id))"><i
                            class="fa-solid fa-eye m-r-5"></i>View</a>
                        <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#edit_banked_time_modal" @click="edit(record)"><i
                            class="fa-solid fa-pencil m-r-5"></i>Edit</a>
                        <!-- <a
                            class="dropdown-item"
                            href="javascript:;"
                            data-bs-toggle="modal"
                            data-bs-target="#delete_approve"
                            @click="deleteClicked(record.id)"
                            ><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a
                          > -->
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
          <div class="d-flex justify-content-center text-center mt-5" v-else>
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <a-pagination v-model:current="current" v-model:pageSize="perPage" :total="total" @change="pendingList"
              show-less-items class="mt-3 " :showSizeChanger="false">
              <template #itemRender="{ type, originalElement }">
                <a v-if="type === 'prev'">Previous</a>
                <a v-else-if="type === 'next'">Next</a>
                <component :is="originalElement" v-else></component>
              </template>
            </a-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <leaves-admin-modal ref="leaveAdmin" @allLeaves="pendingList"></leaves-admin-modal>
    <sick-leave-details-modal ref="sickLeaveDetails"></sick-leave-details-modal>
    <sick-leave-modal ref="sickLeave"></sick-leave-modal>
    <edit-employee-modal ref="editEmployee" @editedUser="getEmployees"></edit-employee-modal>
    <add-face-template-modal ref="addface"></add-face-template-modal>
    <face-templates-modal ref="faceTemplates"></face-templates-modal>
    <employee-report-modal ref="employeeReportModal"></employee-report-modal>
    <reset-password-modal ref="resetPasswordModal"></reset-password-modal>
    <assign-employee-modal ref="assignEmployeeModal" @updated="getEmployees"></assign-employee-modal>
  </div>
  <edit-banked-time-modal ref="editBankedTime"></edit-banked-time-modal>
  <banked-time-details-modal ref="viewBankedTime" @statusUpdated="pendingList" @edit="edit"></banked-time-details-modal>
  <!-- /Page Wrapper -->
    <view-banked-time-details-modal ref="viewBankedTimeDetails"></view-banked-time-details-modal>
</template>

<script>
import axios from "axios";
import { Modal } from 'bootstrap';
import { VUE_APP_API_BASE_URL } from "../../../config";
import { formatUSDate, minToTimeString, formatDateTimeStandardShort, formatDateTimeStandardWithTime } from "@/utils/util-funcitons";
import { dateRangeStart, dateRangeEnd } from "@/utils/util-var";
import ActionDropdown from "@/components/action-dropdown.vue";
import FaceTemplatesModal from "@/components/modal/face-templates-modal.vue";
import AssignEmployeeModal from "@/components/modal/assign-employee-modal.vue";


const columns = [
  {
    title: "Employee",
    dataIndex: "user_id",
    key: "user_id",
    width: 200,
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    width: 130,
  },
  {
    title: "Value",
    dataIndex: "work_in_minutes",
    key: "work_in_minutes",
    width: 110,
  },
  {
    title: "Comment",
    dataIndex: "comment",
    key: "comment",
    width: 180,
    ellipsis: true,
  },

  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 130,
  },
  {
    title: "Updated By",
    dataIndex: "updated_by",
    key: "updated_by",
    width: 170,
    ellipsis: true,
  },
  {
    title: "Updated At",
    dataIndex: "updated_at",
    key: "updated_at",
    width: 160,
  },
  {
    title: "Action",
    key: "action",
    text: "end",
    width: 70,
  },
];

// const d = new Date();
// const dateRangeStart = new Date(d.setMonth(d.getMonth() - 1));
// const dateRangeEnd = new Date();
import { monitorMixin } from "@/mixins/monitorMixin";
export default {
  mixins: [monitorMixin],
  components: {
    ActionDropdown,
    FaceTemplatesModal,
    AssignEmployeeModal
  },
  data() {
    return {
      columns,
      title: "Additional Shift Time",
      path: "Dashboard",
      text: "Additional Shift Time",
      userLeavesData: null,
      perPage: 10,
      current: 1,
      total: 0,
      employeeName: "",
      leaveType: null,
      leaveStatus: null,
      employeeData: [],
      loading: false,
      startDate: formatUSDate(dateRangeStart),
      endDate: formatUSDate(dateRangeEnd),
    };
  },
  methods: {
    formatDateTimeStandardWithTime,
    bankedTimeClicked(record) {
      if(this.$refs.viewBankedTimeDetails) {
        this.$refs.viewBankedTimeDetails.updateValues(record, {});
      }
    },

    async pendingList() {

      await axios.post(`${VUE_APP_API_BASE_URL}/banked-time/get-non-banked-time-user-pending-list?page=${this.current}`, { per_page: this.perPage }).then((response) => {
        if (response.data.status) {
          this.userLeavesData = response.data.data.data;
          this.userLeavesData.forEach(e => {
            e['us_date'] = new Date(e['date'])
            let dateVar = new Date(e['date'])
            e['date'] = formatDateTimeStandardShort(dateVar)
          })
          this.current = response.data.data.current_page;
          this.total = response.data.data.total;
        }
      }).catch(function (error) {
        console.log(error);
      })
        .finally(() => {
          this.loading = false;
        });
    },

    edit(item) {
      this.$refs.editBankedTime.updateValues(item);
    },

    view(item, name) {
      this.$refs.viewBankedTime.updateValues(item, name);
    },

    toTimeString(minutes) {
      return minToTimeString(minutes);
    },

    viewReport(record) {
      this.$refs.employeeReportModal.updateValues(record.id, this.startDate, this.endDate);
      const modal = new Modal(document.getElementById('employee_report_modal'));
      modal.show();
    },
    resetPasswordClicked(record) {
      this.$refs.resetPasswordModal.updateValues(record);
    },
    assignEmployeeClicked(record) {
      this.$refs.assignEmployeeModal.updateValues(record);
    },

    async updateStatus(id, option) {
      await axios.post(`${VUE_APP_API_BASE_URL}/task/${id}/update-status`, {
        status: option,
      }).then((response) => {
        if (response.data.status) {
          this.$toast.success(response.data.message);
          this.pendingList();
        } else {
          this.$toast.error(response.data.message || response.data.errors);
          // this.errorMessage = response.data.message ?? "";
        }

      }).catch(function (error) {
        console.log('error ', error);
      });
    },

    getEmployees() {


      axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.employeeData = response.data.data;

            this.employeeData.forEach(element => {
              element["text"] = element["first_name"] + " " + element["last_name"];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {

        });
    },

    getEmployeeName(id) {
      const name = this.employeeData.find(item => item.id === id);
      return name ? name.text : '-';
    },

    sickLeaveClicked(record) {
      this.$refs.sickLeave.updateValues(record);
    },
    addFaceTemplateClicked(record) {
      this.$refs.addface.updateValues(record);
    },
    faceTemplatesClicked(employee) {
      this.$refs.faceTemplates.showTemplates(employee);
    },
    editClicked(record) {
      this.$refs.editEmployee.updateValues(record);
    },
    leavesClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/leaves-employee', query: { id: record.user_id } });
      window.open(routeData.href, '_blank');
    },
    attendanceClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/attendance-employee', query: { id: record.user_id } });
      window.open(routeData.href, '_blank');
    }
  },
  mounted() {
    this.pendingList();
    this.getEmployees();
  }
};
</script>
<style scoped>
.custom-select select {
  appearance: none;
  width: 50px;
  font-size: 14px;
  padding: 2px 5px;
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  color: #000;
  cursor: pointer;
}
</style>